import React, { lazy, Suspense } from 'react';
import PrivateRoute from '../../../routes/PrivateRoute';
import { Spinner } from '../../Common/Spinner';
import PublicRoute from '../../../routes/PublicRoute';

const PartnerListTable = lazy(() => import('./List/PartnerListTable'));
const PartnerForm = lazy(() => import('./PartnerForm'));
const PartnerProfilePage = lazy(() => import('./PartnerProfilePage'));

const PartnerRouter = (props) => (
    <Suspense fallback={<Spinner />}>
        <PrivateRoute path="/list/global_partners" searchString={props.searchString} component={PartnerListTable} exact />
        <PrivateRoute path="/global_partners/profile/:id" component={PartnerProfilePage} exact />
        <PublicRoute path="/global/partners/:organization_id" component={PartnerForm} exact />
    </Suspense>
)

export default PartnerRouter;
